import { IQueryData } from '@Reducers/common';
import { IConsultationType } from '@Reducers/consultation';
import { ScheduleType } from '@Services/Common/common-payload';
import { CONSULTATION_TYPE, INSTANT_LOCATION_CODE } from '@Utils/constants';
import { formatName } from '@Utils/helper';

export const getHeaderTitle = (queryData: IQueryData, consultationType: IConsultationType) => {
  switch (true) {
    case queryData?.scheduleType === ScheduleType.Lab:
      return 'Schedule Sample Collection';
    case queryData?.locationCode === INSTANT_LOCATION_CODE:
      return 'Instant Consultation';
    default:
      return `${formatName(queryData?.appointmentState) || 'Schedule'} ${
        consultationType?.consultationCode === CONSULTATION_TYPE.SC ? 'Consultation' : consultationType?.name
      }`;
  }
};
